import { get } from '@/helpers';

export const getShippingFee = (shippingMethod, net = false) => {
  let fee = 0;
  switch (shippingMethod.price_type) {
    case 'flat-rate': {
      let key = 'value';
      if (net) key = 'net_value';
      fee = get(shippingMethod, `mainPrice.${key}`, 0);
      break;
    }

    case 'country':
      // TODO
      break;

    // TODO
    // process other price types
  }
  return fee;
};

export const getPropertyValues = pivot => {
  const property = pivot?.property;
  const valueField = pivot?.property?.propType?.value_field;
  const valueFieldAlt = pivot?.property?.propType?.value_field_alt;

  const values = pivot?.values || [];
  // return values.map(el => ({ label: property.name, value: el[valueField] || el[valueFieldAlt] }))

  return { label: property?.name, values: values.map(el => el[valueField] || el[valueFieldAlt]) };
};
